import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MotionConfig } from 'motion/react'
import { App } from './App'
import { Providers } from './components/providers'
import 'styles/tailwind.css'
import '@radix-ui/themes/styles.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Providers>
        {/* reducedMotion="user": skip transform animations when the OS asks for less motion */}
        <MotionConfig reducedMotion="user">
          <App />
        </MotionConfig>
      </Providers>
    </BrowserRouter>
  </React.StrictMode>
)
